var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (direction, html) {var ariaSort = direction > 0 ? 'ascending' : direction < 0 ? 'descending' : 'none';
pug_html = pug_html + "\u003Cdiv" + (" class=\"grid-sortable-header\""+pug.attr("aria-sort", ariaSort, true, true)) + "\u003E";
if (direction > 0) {
pug_html = pug_html + "\u003Cspan class=\"grid-asc sort-indicator\"\u003E\u003C\u002Fspan\u003E";
}
if (direction < 0) {
pug_html = pug_html + "\u003Cspan class=\"grid-des sort-indicator\"\u003E\u003C\u002Fspan\u003E";
}
pug_html = pug_html + (null == (pug_interp = html) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";}.call(this,"direction" in locals_for_with?locals_for_with.direction:typeof direction!=="undefined"?direction:undefined,"html" in locals_for_with?locals_for_with.html:typeof html!=="undefined"?html:undefined));;return pug_html;};
module.exports = template;